module.exports = __webpack_public_path__ + "static/media/lets_talk_awesome-IG-2.809d16de.PNG";